<template>
  <div class="page-content">
    <page-template ref="goodsTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :detailColumns="detailColumns"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import userPower from '@/mixin/userPower'
  import api from '@/config/api';
  import date from '@/mixin/date'

  export default {
  mixins: [userPower, date],
  components: {
    pageTemplate
  },
  data() {
    return {
      searchOptions: {
        simple: [
          {label: '盘点批号', prop: 'orderNo', type: 'input', ifFuzzy: true, placeholder: "请输入盘点单号"},
        ],
        complex: [
          {label: "选择日期", prop: "CreateDttm", type: "dateTimeRangeButton", dateType: "datetime", span: 24},
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            data: [],
            isHasAll: true,
            span: 12,
            url: api.system.seStore,
            // disabled: true,
          },
          {
            label: "制单人",
            type: "input",
            prop: "voucherName",
            span: 12,
          },
          {
            label: "审核人",
            type: "input",
            prop: "reviewerName",
            span: 12,
          },
          // {
          //   label: '盘点范围',
          //   prop: 'type',
          //   type: 'radio', span: 8,
          //   data: [{label: '全场盘点', value: 10}, {label: '单品盘点', value: 20}, {label: '类别盘点', value: 30}, {
          //     label: '品牌盘点',
          //     value: 40
          //   },],
          // },
          {
            label: '审核状态',
            type: 'select',
            prop: 'reviewerStatus',
            defaultValue: 20,
            span: 12,
            data: [
              // {label: '全部', value: undefined},
              {label: '未审核', value: 20},
              {label: '已审核', value: 10}
            ],
          },
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '新增',
          code: 'insert',
          callback: this.addGoods
        },
        {
          label: '刷新',
          code: 'refresh',
          filter: () => {
            return false
          }
        },
        {
          label: '编辑',
          type: this.$utils.buttonType.tableOperate,
          code: 'update',
          callback: this.toEditPage,
          filter: (data) => {
            return data.reviewerStatus == 10 ? false : true;
          },
        },
        {
          label: '导出',
          code: 'export',
          callback: this.goodsDetailExport,
          filter: () => {
            return false
          }
        },
        {
          label: '删除',
          code: 'delete',
          type: this.$utils.buttonType.tableOperate,
          filter: (data) => {
            return data.reviewerStatus == 10 && data.status != 25 ? false : true;
          },
        },
      ],
      // 表格信息配置
      tableOptions: {
        tableName: 'clearTable',
        showSelect: true,
        indexShow: true,//是否显示索引
        columns: [
          {
            label: '盘点批号',
            prop: 'batchOrderNo',
            width: '220',
            align: 'center',
            // showDetail: true
          },
          {
            label: '盘点单号',
            prop: 'orderNo',
            width: '220',
            align: 'center',
            // showDetail: true
            callback: this.goOrderDetail
          },
          {
            label: '仓库',
            prop: 'warehouseName',
            width: '190',
            align: 'center'
          },
          {
            label: '盘点范围',
            prop: 'type',
            width: '120',
            align: 'center',
            enumData: this.$utils.getCacheStatus('weBlitemOrder.type')
          },
          {
            label: '审核状态',
            prop: 'reviewerStatus',
            width: '100',
            align: 'center',
            enumData: this.$utils.getCacheStatus('weBlitemOrder.reviewerStatus')
          },
          {label: '制单人', prop: 'voucherName', width: '80', align: 'center'},
          {label: '制单时间', prop: 'voucherDttm', width: '150', align: 'center'},
          {label: '审核人', prop: 'reviewerName', width: '80', align: 'center'},
          {label: '审核时间', prop: 'reviewerDttm', width: '150', align: 'center'},
          {label: '备注', prop: 'remarks', width: '80', align: 'center',},
        ],
        param: {reviewerStatus: 20, stCreateDttm: this.getStMonthDate(), edCreateDttm: this.getEdMonthDate()},
        url: api.warehouse.blitem
      },
      // 详情
      detailColumns: {
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png'
          },
          right: '350px',
          top: '30px'
        },
        span: 8,
        labelWidth: "130",
        columns: [
          {
            label: '仓库',
            prop: 'warehouseName',
            span: 12,
          },
          {
            label: '盘点单批号',
            prop: 'batchOrderNo',
            span: 12,
          }, {
            label: '盘点范围',
            prop: 'type',
            span: 12,
            enumData: this.$utils.getCacheStatus('weBatchNumberOrder.type')
          }, {
            label: '备注',
            prop: 'remarks',
            span: 12
          },
          {
            label: '盘点信息',
            prop: 'retaleInfo',
            span: 12,
          },],
        tablesProp: {
          weBlitemGoodsMapMVOList: {
            url: api.warehouse.weBlitemGoodsMap + "/page",
            height: this.detailHeight,
            indexShow: true,
            tableName: "weBlitemGoodsMapMVOList",
            showSummary: true,
            summaryColumns: ['blitemNum'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '230',
                align: 'center',
              },
              {
                label: '商品名称',
                prop: 'goodsName',
                align: 'center',
                width: '230'
              },
              {
                label: '单位',
                prop: 'unitName',
                align: 'center',
                width: '120'
              },
              {
                label: '成本价',
                prop: 'purchasePrice',
                align: 'center',
                width: '110'
              },
              {
                label: '数量',
                width: '110',
                align: 'center',
                prop: 'blitemNum',
              },
              {
                label: '成本金额',
                prop: 'amountInventory',
                align: 'center',
                width: '110',
              },
              {
                label: '类别',
                prop: 'goodsCategoryName',
                align: 'center',
                width: '130'
              },
              {
                label: '品牌',
                prop: 'goodsBrandName',
                align: 'center',
                width: '150'
              },
              {
                label: '备注',
                prop: 'remarks',
                align: 'center',
                width: '220',
              },
            ],
          }
        },

        printTablesProp: {
          weBlitemGoodsMapMVOList: {
            tableName: 'weBlitemGoodsMapMVOList',
            showSummary: true,
            summaryColumns: ['blitemNum', 'amountInventory'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '230',
                align: 'center',
              },
              {
                label: '商品名称',
                prop: 'goodsName',
                align: 'center',
                width: '230'
              },
              {
                label: '单位',
                prop: 'unitName',
                align: 'center',
                width: '120'
              },
              {
                label: '类别',
                prop: 'goodsCategoryName',
                align: 'center',
                width: '130'
              },
              {
                label: '品牌',
                prop: 'goodsBrandName',
                align: 'center',
                width: '150'
              },
              {
                label: '成本价',
                prop: 'purchasePrice',
                align: 'center',
                width: '110'
              },
              {
                label: '数量',
                width: '110',
                align: 'center',
                prop: 'blitemNum',
              },
              {
                label: '价格',
                prop: 'amountInventory',
                align: 'center',
                width: '110',
              },
              {
                label: '备注',
                prop: 'remarks',
                align: 'center',
                width: '220',
              },
            ],
          },
        },
        url: api.warehouse.blitem
      }


    };
  },
  created() {
    this.setStore(this.searchOptions.complex);
    this.$utils.setDataByKey(this.$utils.localStorageKeys.pageSize, 10);
  },
  destroyed() {
    this.$utils.setDataByKey(this.$utils.localStorageKeys.pageSize, 10);
  },
  methods: {
    goOrderDetail(row) {
      if (25 === row.status) {
        this.$message({message: '盘点商品正在导入，无法进行操作。', type: 'warning'});
      } else {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.detailColumns);
        this.$router.push({
          path: '/warehouse/inventory/goods/detail?id=' + row.id,
          query: {redirect: '/warehouse/inventory/goods'}
        }).catch(err => {
        });
      }
    },
    toEditPage(row) {
      if (25 === row.status) {
        this.$message({message: '盘点商品正在导入，无法进行操作。', type: 'warning'});
      } else {
        this.$router.push({path: '/warehouse/inventory/goods/add?id=' + row.id});
      }
    },
    addGoods() {
      this.$router.push({path: '/warehouse/inventory/goods/add'});
    },
    goodsDetailExport() {
      let selectData = this.$refs["goodsTemplate"].$refs["tableTemp"].selectRow;
      if (selectData.length === 0) {
        this.$confirm('请选择一条数据！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } else {
        if (selectData.length > 1) {
          this.$confirm('只能选择一条数据！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$refs["goodsTemplate"].$refs["tableTemp"].$refs["clearTable"].clearSelection();
          })
        } else {
          console.log(selectData[0].id);
          this.$axios.fetchPost(api.warehouse.goodsGoodsExport, {
            id: selectData[0].id,
            exportCode: 'WeBlitemGoodsExport'
          }).then(data => {
            if (data.code === 200) {
              const elink = document.createElement('a');
              elink.href = data.data;
              elink.click();
              this.loadingExt = false;
              this.$notify({
                type: "success",
                title: '导出操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '导出成功', type: 'success'});
            } else {
              this.$notify({
                type: "error",
                title: '导出操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({message: '导出异常', type: 'error'});
            }
          })
        }
      }
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/warehouse/inventory/Goods.vue